import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
var SettingsService = /** @class */ (function () {
    function SettingsService(http, auth) {
        this.http = http;
        this.auth = auth;
        // this.URL = `${environment.baseServerURLOld}/company`;
        this.URL = environment.baseServerURL + "/administration/bot";
    }
    SettingsService.prototype.buildURL = function (subPath) {
        return this.URL + "/" + subPath + "/" + this.auth.user.company.id;
    };
    SettingsService.prototype.webFetchURL = function () {
        return environment.baseServerURL + "/orchestrator/tenant-config/" + this.auth.user.company.id + "/web-fetch";
    };
    SettingsService.prototype.getBotSettings = function () {
        return this.http.get(this.buildURL('settings'), {
            withCredentials: true
        });
    };
    SettingsService.prototype.updateBotSettings = function (settings) {
        return this.http.put(this.buildURL('settings'), settings, {
            withCredentials: true
        });
    };
    /**
     * The web-access flag the Agent Orchestrator actually reads on every turn. The bot's own
     * `agenticWebEnabled` is only this screen's copy, so the toggle shows this value.
     */
    SettingsService.prototype.getWebFetchConfig = function () {
        return this.http.get(this.webFetchURL(), {
            withCredentials: true
        });
    };
    SettingsService.prototype.updateWebFetchConfig = function (webFetchEnabled) {
        var url = this.webFetchURL();
        return this.http.patch(url, {
            web_fetch_enabled: webFetchEnabled
        }, {
            withCredentials: true
        });
    };
    /***********************************************************************
     * PROMPT GPT IMPLEMENTATION
     */
    SettingsService.prototype.getPrompt = function (company) {
        var URL = environment.baseServerURL + "/administration/company/" + company + "/getPrompt";
        return this.http.get(URL, {
            withCredentials: true
        });
    };
    SettingsService.prototype.setPrompt = function (req) {
        var prompt = req.prompt, company = req.company;
        var URL = environment.baseServerURL + "/administration/company/" + company + "/setPrompt";
        return this.http.patch(URL, { prompt: prompt }, {
            withCredentials: true
        });
    };
    SettingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SettingsService_Factory() { return new SettingsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: SettingsService, providedIn: "root" });
    return SettingsService;
}());
export { SettingsService };
